import React, { useEffect, useState } from "react";
import { product_actions } from "../../redux-store";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import ProductInfoCard from "../common/cards/ProductInfoCard";
import ReactPaginate from "react-paginate";
import useDebounce from "./Dashboard/components/AdWorkShop/hooks/useDebounce";
import backend from "../../api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Skeleton } from "@mui/material";

const sortOptions = [
  { option: "Most Recent", value: "" },
  { option: "Highest Reward", value: "descending_rewards" },
  { option: "Lowest Reward", value: "ascending_rewards" },
];

const Product = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [merchantId, setMerchantId] = useState("" || id);
  const [sortby, setSortby] = useState("");
  const [merchantList, setMerchantList] = useState([]);
  const { data: products, total: totalProducts } = useSelector(
    (state) => state.products
  );
  const { user } = useSelector((state) => state?.auth);
  const { loading } = useSelector((state) => state.global);

  const debouncedSearch = useDebounce(search, 500);

  const fetchProducts = (
    page = 1,
    search = "",
    merchantId = "",
    sortby = ""
  ) => {
    dispatch(
      product_actions.fetch_products({
        page,
        limit: 9,
        search,
        merchantId,
        sortby,
        published: true,
        member_user: user?.user?._id, // Pass the member_user ID to the API call
      })
    );
  };

  const fetchMerchants = async () => {
    try {
      const response = await backend.get("/user", {
        params: { role: "merchant",limit : 9999 },
      });
      setMerchantList(response?.data?.data);
    } catch (error) {
      toast.error(error.response ? error.response.data.message : error.message);
    }
  };

  const handlePageChange = ({ selected }) => {
    setPage(selected + 1);
  };

  useEffect(() => {
    fetchProducts(page, debouncedSearch, merchantId, sortby);
  }, [page, debouncedSearch, merchantId, sortby]);

  useEffect(() => {
    fetchMerchants();
  }, []);

  return (
    <>
      <Helmet>
        <title>eksplode! | Products</title>
      </Helmet>
      <div className="dashboard">
        <div className="box-account box-info">
          <div className="box-head px-5">
            <h2>Product List</h2>
          </div>
          <div className="row mt-3">
            <div className="col-lg-12 mx-auto register-page section-b-space">
              <div className="theme-card">
                <form className="theme-form">
                  <div className="form-row">
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control mb-0"
                        placeholder="Search Products"
                        onChange={(e) => {
                          setPage(1);
                          setSearch(e.target.value);
                        }}
                        value={search}
                      />
                    </div>
                    <div className="col-md-6">
                      <select
                        value={merchantId}
                        className="form-control mb-0"
                        onChange={(e) => {
                          setPage(1);
                          setMerchantId(e.target.value);
                        }}
                        disabled={id}
                      >
                        <option selected value="">
                          All Merchants
                        </option>
                        {merchantList?.map((merchant) => {
                          return (
                            <option value={merchant?._id} key={merchant?._id}>
                              {merchant?.first_name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    {user?.user?.role === "member" && (
                      <div className="col-md-6">
                        <select
                          defaultValue={""}
                          className="form-control mb-0"
                          onChange={(e) => {
                            setPage(1);
                            setSortby(e.target.value);
                          }}
                        >
                          {sortOptions.map((el) => {
                            return (
                              <option value={el.value} key={el.value}>
                                {el.option}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-12 mx-auto register-page section-b-space">
              <div className="container">
                {products?.length > 0 ? (
                  <div className="row">
                    {products?.map((el, index) => {
                      return (
                        <div
                          className="col-12 col-lg-6 col-xl-4 mb-3"
                          key={index}
                        >
                          {loading ? (
                            <Skeleton
                              variant="rounded"
                              height={305}
                            />
                          ) : (
                            <ProductInfoCard data={el} />
                          )}
                        </div>
                      );
                    })}
                    <div className="col-12">
                      <div className="d-flex justify-content-center mt-5">
                        <ReactPaginate
                          previousLabel={"<<"}
                          nextLabel={">>"}
                          breakLabel={"..."}
                          pageCount={Math.ceil(totalProducts / 9)}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageChange}
                          containerClassName={"pagination"}
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextClassName={"page-item"}
                          nextLinkClassName={"page-link"}
                          breakClassName={"page-item"}
                          breakLinkClassName={"page-link"}
                          activeClassName={"active"}
                          forcePage={page - 1}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="w-100 col-lg-12 col-md-12 col-sm-12 section-b-space mt-5 no-found text-center">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/empty-search.jpg`}
                        className="img-fluid mb-4"
                        alt="No products found"
                      />
                      <h3>
                        Sorry! Couldn't find the product you were looking for!
                      </h3>
                      <p>
                        Please check if you have misspelled something or try
                        searching with other words.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
